import { UserService } from '@/app/services/user'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IUserCoursesRecommendations } from '@/types/user'
import { useQuery, UseQueryOptions } from 'react-query'

export const useUserCourseRecommendations = (
  options?: Omit<
    UseQueryOptions<
      IApiIndividualResponse<IUserCoursesRecommendations>,
      ErrorResponse
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery(
    [UserService.RECOMMENDATIONS_PATH],
    UserService.getRecommendations,
    options
  )
}
